<template>
  <v-snackbar v-model="snackbar.show" :timeout="5000" :color="snackbar.color" bottom>
    <span class="white--text">{{ snackbar.message }}</span>
    <template v-slot:action="{ attrs }">
      <v-btn color="white" icon v-bind="attrs" @click="closeSnackbar">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>

export default {

  methods: {
    closeSnackbar() {
      this.$store.commit("HIDE_SNACKBAR");
    },
  },
  computed: {
    snackbar() {
      return this.$store.state.snackbar
    },
  }

};
</script>
